import {
  DE,
  ES,
  type FlagComponent,
  FR,
  GB,
  GR,
  HR,
  IT,
  JP,
  PL,
  SI,
} from "country-flag-icons/react/3x2";
import { UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";

export const AVAILABLE_LANGS_OPTIONS: NonNullable<UserEntityPreferredLanguage>[] =
  [
    UserEntityPreferredLanguage.de,
    UserEntityPreferredLanguage.en,
    UserEntityPreferredLanguage.es,
    UserEntityPreferredLanguage.fr,
    UserEntityPreferredLanguage.it,
    UserEntityPreferredLanguage.jp,
  ];

/**
 * Set of available languages for O(1) lookup without type casting
 */
export const AVAILABLE_LANGS_SET: Set<string> = new Set(
  AVAILABLE_LANGS_OPTIONS
);

/**
 * Display names for languages (in their own language)
 */
export const LANG_DISPLAY_NAMES: Record<
  NonNullable<UserEntityPreferredLanguage>,
  string
> = {
  [UserEntityPreferredLanguage.fr]: "Français",
  [UserEntityPreferredLanguage.en]: "English",
  [UserEntityPreferredLanguage.de]: "Deutsch",
  [UserEntityPreferredLanguage.it]: "Italiano",
  [UserEntityPreferredLanguage.es]: "Español",
  [UserEntityPreferredLanguage.jp]: "日本語",
  [UserEntityPreferredLanguage.gr]: "Ελληνικά",
  [UserEntityPreferredLanguage.pl]: "Polski",
  [UserEntityPreferredLanguage.hr]: "Hrvatski",
  [UserEntityPreferredLanguage.sl]: "Slovenščina",
};

/**
 * Explicit mapping of language codes to flag components
 * Avoids dynamic indexing and type assertions
 */
export const FLAG_COMPONENTS: Record<
  NonNullable<UserEntityPreferredLanguage>,
  FlagComponent
> = {
  [UserEntityPreferredLanguage.fr]: FR,
  [UserEntityPreferredLanguage.en]: GB,
  [UserEntityPreferredLanguage.de]: DE,
  [UserEntityPreferredLanguage.it]: IT,
  [UserEntityPreferredLanguage.es]: ES,
  [UserEntityPreferredLanguage.jp]: JP,
  [UserEntityPreferredLanguage.gr]: GR,
  [UserEntityPreferredLanguage.pl]: PL,
  [UserEntityPreferredLanguage.hr]: HR,
  [UserEntityPreferredLanguage.sl]: SI,
};

/**
 * Default language fallback
 */
export const DEFAULT_LANG = UserEntityPreferredLanguage.en;
